import { render, staticRenderFns } from "./MonthLockDataTable.vue?vue&type=template&id=194b4988"
import script from "./MonthLockDataTable.vue?vue&type=script&lang=js"
export * from "./MonthLockDataTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports